// 事例セクション Swiper
const caseSwiper = new Swiper(".js-swiper", {
  speed: 1000,
  loop: true,
  autoplay: {
    delay: 2000,
    disableOnInteraction: false,
  },
  centeredSlides: true,
  slidesPerView: "auto",
  spaceBetween: 0,
  watchOverflow: true,
  pagination: {
    el: ".js-swiper .p-case__pagination",
    clickable: true,
  },
});

// ページ初期状態では、wrapperのmargin-leftを無効にしておく
// （Swiperが1pxでも動いたら有効化する）
const swiperWrapper = document.querySelector(".js-swiper-wrapper");

if (swiperWrapper) {
  let marginApplied = false;
  let isInit = true;
  let startTranslate = 0;

  const enableMargin = () => {
    if (marginApplied) return;
    marginApplied = true;
    swiperWrapper.classList.add("is-swiper-margin-applied");
  };

  caseSwiper.on("setTranslate", (swiper, translate) => {
    // 初期化時は基準値だけ取ってスキップ
    if (isInit) {
      isInit = false;
      startTranslate = translate;
      return;
    }

    // 1px以上動いたら発火
    if (Math.abs(translate - startTranslate) >= 1) {
      enableMargin();
    }
  });
}